import { emptyObj } from '@beef/utils';
import { getContentData } from "../selectors";
// fixme

export var getActionBar = function getActionBar(state) {
  return getContentData(state).actionBarWithBackCall || emptyObj;
};
export var getActionBarTitle = function getActionBarTitle(state) {
  return getActionBar(state).title;
};
export var getActionBarSubTitle = function getActionBarSubTitle(state) {
  return getActionBar(state).subTitle;
};
export var getActionBarButton = function getActionBarButton(state) {
  return getActionBar(state).button || emptyObj;
};